import Vue from "vue";

Vue.filter("capitalize", (value) => {
  return value
    .split(" ")
    .map(
      (x) =>
        `${x.substring(0, 1).toUpperCase()}${x.substring(1).toLowerCase()}`,
    )
    .join(" ");
});
